<template lang="">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :height="height"
    :width="width"
    viewBox="0 -960 960 960"
  >
    <path
      d="M774.999-142.309q-111.615 0-224.615-57.308-112.999-57.307-203.999-148.115-90.999-90.807-148.307-203.614-57.307-112.807-57.307-224.422 0-18.956 12.637-31.593 12.637-12.638 31.593-12.638H299.23q15.3 0 26.689 9.885 11.388 9.885 14.773 26.654l23.923 107.537q2.385 14.769-.692 26.846t-11.781 20.013l-94.296 92.218q57.539 95.692 127.616 165.077Q455.539-302.385 547-252.461l90.385-93.769q10-11 22.423-15.308 12.423-4.308 25.807-1.308l97.076 21.385q16.466 3.375 26.502 15.61 10.036 12.236 10.036 29.313v109.998q0 18.956-12.637 31.593-12.637 12.638-31.593 12.638ZM234.77-577.999l82.538-80.077q1.539-1.539 2.116-4.231.577-2.693.192-5L297.77-768.461q-.385-3.077-2.5-4.615-2.116-1.539-5.193-1.539h-98.538q-2.308 0-3.846 1.539-1.539 1.538-1.539 3.846-.769 39.385 11.808 86.654t36.808 104.577Zm354.768 346.845q41 20.154 89.769 31.384 48.769 11.231 89.154 12.462 2.308 0 3.846-1.539 1.539-1.538 1.539-3.846v-98.153q0-3.078-1.539-5.193-1.538-2.116-4.616-2.5L677-317.231q-2.308-.385-4.039.192-1.731.577-3.654 2.115l-79.769 83.77ZM234.77-577.999Zm354.768 346.845Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
export default {
  props: {
    width: {
      type: Number,
      default: 48,
    },
    height: {
      type: Number,
      default: 48,
    },
  },
};
</script>
<style lang=""></style>
